import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const PendingApproval = () => {
  const { t } = useTranslation();
  const [daysPassed, setDaysPassed] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setDaysPassed(3), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center">
      <h1 className="text-3xl font-bold mb-4">{t("pendingApproval.title")}</h1>
      <p className="text-lg text-gray-600 mb-8">
        {t("pendingApproval.thanks")} <br />
        {t("pendingApproval.reviewing")}
      </p>

      {daysPassed >= 2 && (
        <div className="bg-yellow-100 text-yellow-800 px-6 py-4 rounded-lg mb-4">
          {t("pendingApproval.delayWarning")} <br />
          {t("pendingApproval.contact", { email: "support@artkiv.com" })}
        </div>
      )}

      <p className="text-sm text-gray-500">{t("pendingApproval.emailNotice")}</p>
    </div>
  );
};
